import React from 'react';
import Icon from '../../../components/AppIcon';

const ObservationTypeSection = ({ value, onChange }) => {
  const types = [
    {
      value: 'unsafe-act',
      label: 'Unsafe Act',
      description: 'Behavioral safety concern involving human actions',
      icon: 'User',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      value: 'unsafe-condition',
      label: 'Unsafe Condition',
      description: 'Physical hazard or environmental safety concern',
      icon: 'AlertTriangle',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Observation Type</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {types?.map((type) => (
          <button
            key={type?.value}
            type="button"
            onClick={() => onChange(type?.value)}
            className={`p-4 rounded-lg border-2 transition-all text-left ${
              value === type?.value
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
            }`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-lg ${type?.bgColor} flex items-center justify-center flex-shrink-0`}>
                <Icon name={type?.icon} size={20} className={type?.color} />
              </div>
              <div>
                <h4 className="font-medium text-foreground mb-1">{type?.label}</h4>
                <p className="text-sm text-muted-foreground">{type?.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ObservationTypeSection;